import { getCategoryCssColor } from "../../../../shared/stores/category-store";
import {
  getEventPosition,
  pxToTime,
} from "../../utils/time-positioning";
import { useFormPreview } from "../../stores/form-preview-store";

interface SlotCreationPreviewBlockProps {
  readonly date: string;
  readonly topPx: number;
  readonly heightPx: number;
  readonly column?: number;
  readonly totalColumns?: number;
}

export function SlotCreationPreviewBlock({
  date,
  topPx,
  heightPx,
  column = 0,
  totalColumns = 1,
}: SlotCreationPreviewBlockProps) {
  const formPreview = useFormPreview();

  if (heightPx <= 0) return null;

  const cssColor = formPreview ? getCategoryCssColor(formPreview.category) : null;
  const useFormTimes = formPreview && !formPreview.eventId && formPreview.date === date;
  const pos = useFormTimes
    ? getEventPosition(formPreview.startTime, formPreview.endTime)
    : { topPx, heightPx };
  const displayStart = useFormTimes ? formPreview.startTime : pxToTime(topPx, true);
  const displayEnd = useFormTimes ? formPreview.endTime : pxToTime(topPx + heightPx, true);
  const displayTitle = useFormTimes && formPreview.title ? formPreview.title : null;

  return (
    <div
      className="pointer-events-none absolute z-40 rounded border-2 border-dashed transition-all duration-150 flex flex-col justify-center px-1.5"
      style={{
        top: `${pos.topPx}px`,
        height: `${pos.heightPx}px`,
        left: `calc(${(column / totalColumns) * 100}% + 1px)`,
        width: `calc(${(1 / totalColumns) * 100}% - 2px)`,
        borderColor: cssColor ? `${cssColor}99` : undefined,
        backgroundColor: cssColor ? `${cssColor}26` : undefined,
        ...(!cssColor && { borderColor: 'var(--color-accent)', opacity: 0.6 }),
      }}
    >
      {pos.heightPx >= 40 ? (
        <>
          {displayTitle && (
            <span className="block truncate text-[11px] font-medium text-accent-foreground/80">
              {displayTitle}
            </span>
          )}
          <span className="block truncate text-[10px] text-accent-foreground/60">
            {displayStart}–{displayEnd}
          </span>
        </>
      ) : (
        <span className="block truncate text-[10px] font-medium text-accent-foreground/80">
          {displayTitle ? `${displayTitle} ` : ""}{displayStart}–{displayEnd}
        </span>
      )}
    </div>
  );
}
